import { useState } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import CreateNewChatModal from '../../modals/create-new-chat-modal';

import { ChatFilterTypeEnum } from '../../../../shared/constants/enums';

import './styles.less';
import { FetchChatParams } from '../../models';

export type CreateNewChatProps = {
  updateMessageControl: () => void;
  setSearchValue: (value: string) => void;
  setPageNumber: (pageNumber: number) => void;
  setFetchChatData: React.Dispatch<React.SetStateAction<FetchChatParams | undefined>>;
  chatFilterValue: ChatFilterTypeEnum;
};

const CreateNewChat = ({ updateMessageControl, setSearchValue, setPageNumber, setFetchChatData, chatFilterValue }: CreateNewChatProps) => {
  const [showCreateNewChat, setShowCreateNewChat] = useState<boolean>(false);

  return (
    <>
      <Button onClick={() => setShowCreateNewChat(true)} icon={<EditOutlined />} title="Create new chat" />

      {showCreateNewChat ? (
        <CreateNewChatModal
          visible={showCreateNewChat}
          setSearchValue={setSearchValue}
          updateMessageControl={updateMessageControl}
          closeModal={() => setShowCreateNewChat(false)}
          setPageNumber={setPageNumber}
          setFetchChatData={setFetchChatData}
          chatFilterValue={chatFilterValue}
        />
      ) : undefined}
    </>
  );
};

export default CreateNewChat;
